import { render } from "./SearchResultSort.vue?vue&type=template&id=7e351204"
import script from "./SearchResultSort.vue?vue&type=script&lang=js"
export * from "./SearchResultSort.vue?vue&type=script&lang=js"

import "./SearchResultSort.vue?vue&type=style&index=0&id=7e351204&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__